export default { sha: 'c89222a6fdcc949f60574e0d0f83be5cd111e69a', buildNumber: 'undefined' }
